import React,{useState,useEffect,useRef} from 'react'
import axios from "axios";
import { BASE_URL } from 'apiConfig';

export default function useInsiderTransaction(peerSelected) {
    const [insiderTransaction, setInsiderTransaction] = useState([]);
    const [loadingInsiderTransaction, setLoadingInsiderTransaction] = useState(false);
    const [error, setError] = useState(null);
    
    const previousPeerSelectedRef = useRef([]);
    
    useEffect(() => {
      const isPeerSelectedEqual =peerSelected.every(element => previousPeerSelectedRef.current.includes(element));
    
      if (!isPeerSelectedEqual) {
        getData();
        previousPeerSelectedRef.current = peerSelected;
      }
    }, [peerSelected]);
    
    async function getData() {
      setLoadingInsiderTransaction(true);
      try {
        const response = await axios.get(`${BASE_URL}/insiderTransactionInfo/`, {
          params: {
            ticker: JSON.stringify(peerSelected),
          },
        });
        setInsiderTransaction(response.data);
      } catch (error) {
        console.error(error);
      } finally {
        setLoadingInsiderTransaction(false);
      }
    }
    
    return {insiderTransaction,loadingInsiderTransaction}
}
